export default __webpack_public_path__ + "static/media/contacts.31004a6a.svg";